import React, { useEffect, useState } from "react";
import "./SkillCard.scss";
import { getDomainFromMapping } from "@/utilities";
import districtIcon from "@/images/icons/district-icon.svg";
import {
  fetchStudentSkillStandards,
  selectWeeklyPlanData,
} from "@/store/slices";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useUserData } from "@/hooks/useUserData";
export interface SkillCardProps {
  domain: string;
  skillName: string;
  collapsed: boolean;
  skillId?: string;
  studentId: string;
  lessonPlanId: string;
  userData?: any;
}

const SkillCard: React.FC<SkillCardProps> = ({
  domain,
  skillName,
  collapsed,
  skillId,
  studentId,
  lessonPlanId,

}) => {
  let domainName = getDomainFromMapping(domain);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const data = useSelector(selectWeeklyPlanData);
  const [skillStandards, setSkillStandards] = useState<any[]>([]);
  const [assignmentCategory, setAssignmentCategory] = useState<string[]>([]);
  const userData = useUserData(); 
  const selectedStandard = userData?.sorConfig

  useEffect(() => {
    const fetchStandards = async () => {
      if (skillId && studentId && lessonPlanId) {
        const result: any = await (dispatch as any)(
          fetchStudentSkillStandards({
            input: {
              skillId,
              studentId,
              lessonPlanId,
            },
          })
        );
        setSkillStandards(result.payload?.getStudentSkillStandards || []);
      }
    };
    fetchStandards();
  }, [skillId, studentId, lessonPlanId, dispatch]);

  useEffect(() => {
    if (data?.assignments && skillId) {
      for (const assignment of data.assignments) {
        if (assignment.manifest && Array.isArray(assignment.manifest)) {
          for (const manifestItem of assignment.manifest) {
            if (manifestItem.skills && Array.isArray(manifestItem.skills)) {
              const matchingSkill = manifestItem.skills.find(
                (skill: any) => skill.skillId === skillId
              );
              if (matchingSkill) {
                setAssignmentCategory(assignment.assignmentCategory || []);
                break;
              }
            }
          }
        }
      }
    }
  }, [skillId, data]);

  return (
    <div data-testid={`skill-card-${skillName}`}>
      {!collapsed && (
        <div className="skill-card-inner-container d-flex flex-column">
          <div className="skill-info">
            <div className="skill-header">
              <img src={districtIcon} />
              {assignmentCategory.length > 0 && t(assignmentCategory[0])}
            </div>
            <div className="skill-name-text text-truncate">{skillName}</div>
            <div className="skill-domain-row">
              <div
                className="domain-tag"
                style={{
                  background: domainName.color,
                }}
              >
                {domainName.abbreviation}
              </div>
              {skillStandards.length > 0 && (      
                <div className="skill-standards">
                  {skillStandards.length > 0 && (
                    <span>
                      {skillStandards[0]?.standards[0]?.standardId}
                    </span>
                  )}
                </div>
              )}

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SkillCard;
